import React, { useEffect } from 'react'
import { Box, TextField, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Form, Formik } from 'formik'
import { object, string } from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import { STEPS } from '../../../redux/modules/teamOnboarding'
import SteppedContent from '../../common/SteppedContent'
import ButtonSubmit from '../../common/ButtonSubmit'
import { submitTeamNameStart } from '../../../redux/modules/teamOnboarding'
import { selectErrorTeamDomain } from '../../../redux/selectors/teamOnboardingSelectors'
import {
  publishChangedTeamName,
  publishViewedTeamNameStep,
} from '../../../util/events/teamsOnboardingEventPublishers'

const schema = object().shape({
  teamName: string()
    .required('Company or team name is required.')
    .max(60, 'Company or team name cannot exceed 60 characters.'),
})

const useStyles = makeStyles({
  textField: {
    width: '240px',
  },
})

const StepTeamName = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const isSettingNextStep = useSelector(state => state.teamOnboarding.isSettingNextStep)
  const serviceError = useSelector(selectErrorTeamDomain)

  const handleSubmit = ({ teamName }) => {
    dispatch(submitTeamNameStart(teamName))
  }

  const handleBlurTeamName = (event, error, handleBlur) => {
    handleBlur(event)
    publishChangedTeamName(event.target.value, error)
  }

  useEffect(() => {
    publishViewedTeamNameStep()
  }, [])

  return (
    <SteppedContent
      width="720px"
      title="What's the name of your company or team?"
      description="This will be the name of your Foodsby account - choose something that your team will recognize (e.g., ACME Marketing)."
      progressText={`Step ${STEPS.TEAM_NAME} of 3`}
    >
      <Formik initialValues={{ teamName: '' }} onSubmit={handleSubmit} validationSchema={schema}>
        {({ values, errors, touched, handleChange, handleBlur }) => (
          <Form>
            <TextField
              autoFocus
              name="teamName"
              className={classes.textField}
              placeholder="Company or team name"
              variant="outlined"
              value={values.teamName}
              onChange={handleChange}
              onBlur={e => handleBlurTeamName(e, errors.teamName, handleBlur)}
              error={touched.teamName && Boolean(errors.teamName)}
              helperText={touched.teamName && errors.teamName}
            />
            <Box marginTop={4} marginBottom={2}>
              <ButtonSubmit variant="contained" color="primary" submitting={isSettingNextStep}>
                Next
              </ButtonSubmit>
            </Box>
            {serviceError && <Typography color="error">{serviceError}</Typography>}
          </Form>
        )}
      </Formik>
    </SteppedContent>
  )
}

export default StepTeamName
